<template>
  <div>
    <BookCoach
      v-if="isBookCoachScreenShown"
      @previous="hideBookCoachScreen"
      :coachId="selectedCoachId"
    />
    <div v-else class="select-coach">
      <h3 class="brand-text select-coach-title p-0 mb-5">
        Choose a coach
      </h3>
      <b-spinner v-if="isGetCoachesLoading" class="brand-primary"></b-spinner>
      <div v-else-if="coaches && coaches.length" class="coach-list mb-5">
        <CoachCard
          v-for="coach in coaches"
          @select="handleCoachSelect"
          :coachData="coach"
          :key="coach.id"
        />
      </div>
      <h4 v-else class="select-coach-subtitle brand-text">
        ...Sorry, no coaches are available. Please try again later.
      </h4>
      <div
        class="d-flex justify-content-end align-self-end pt-5 dmh-btn-container"
      >
        <b-button
          @click="handleBtnClick"
          variant="cta-outline"
          size="lg"
          class="py-4 px-4"
          squared
          >Previous
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import config from "../../config/constants";
import CoachCard from "./CoachCard.vue";
import BookCoach from "./BookCoach.vue";

export default {
  name: "SelectCoach",
  components: {
    CoachCard,
    BookCoach
  },
  props: {
    handleBtnClick: {
      type: Function,
      required: true,
      default: () => {}
    }
  },
  data() {
    return {
      coaches: [],
      isGetCoachesLoading: false,
      selectedCoachId: null,
      isBookCoachScreenShown: false
    };
  },
  mounted() {
    this.getCoaches();
  },
  methods: {
    async getCoaches() {
      if (this.isGetCoachesLoading) return;
      try {
        this.isGetCoachesLoading = true;
        const payload = {
          user_id: this.$store.getters.user_id
        };
        const res = await axios.post(
          config.api_env + "/application/api/u/coach/get-coaches",
          payload,
          config.options
        );
        if (res.data.success) {
          this.coaches = res.data.coaches;
        } else if (res.data.err && res.data.err.includes("3994")) {
          this.$store.dispatch("logout");
          this.$router.push("/login");
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.isGetCoachesLoading = false;
      }
    },
    handleCoachSelect(coachId) {
      this.selectedCoachId = coachId;
      this.isBookCoachScreenShown = true;
    },
    hideBookCoachScreen() {
      this.isBookCoachScreenShown = false;
    }
  }
};
</script>

<style lang="less">
.select-coach {
  .coach-list {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .select-coach-title {
    text-align: left;
    font-size: 2.2rem;
    letter-spacing: 0;
    padding-top: 0;
    font-family: "PlusJakartaSansBold";
  }

  .select-coach-subtitle {
    text-align: left;
    font-size: 1.8rem;
    letter-spacing: 0;
    font-family: "PlusJakartaSansBold";
    margin-bottom: 20px;
  }

  .dmh-btn-container {
    gap: 24px;
  }
}

.modal-content.coach_modal {
  border-radius: 16px;
}

@media only screen and (max-width: 576px) {
  .select-coach {
    .dmh-btn-container {
      gap: 16px;
    }
  }
}
</style>
